import React, { useEffect, useRef, useState } from 'react';

import useClickOutside from '@hooks/useClickOutside';

import ProductTags from '@features/collection/details/ProductTags';

const DesignTags = ({
	dropdownTagList = [],
	isEdit,
	productTags = [], // list of tags in the product
	productId,
	updateTagList,
	getAllTags,
	currentProductTagList,
	remarks,
	setRemarks
}) => {
	const [showTagModal, setShowTagModal] = useState(false);
	const productTagRef = useRef();

	const remarksRef = useRef();

	useEffect(() => {
		if (remarksRef.current) {
			remarksRef.current.focus();
			remarksRef.current.style.height = 'auto';
			remarksRef.current.style.height = `${remarksRef.current.scrollHeight}px`;
		}
	}, [remarksRef.current, productTags.length]);

	const handleClickOutSide = () => {
		setShowTagModal(false);
	};

	useClickOutside(productTagRef, handleClickOutSide);

	const toggleTagModal = () => {
		if (isEdit) {
			setShowTagModal((prev) => !prev);
		}
	};

	const handleRemarksChange = (e) => {
		setRemarks(e.target.value);
		// Adjust height automatically when user types
		e.target.style.height = 'auto';
		e.target.style.height = `${e.target.scrollHeight}px`;
	};

	return (
		<div className="style-single style-single-tag" ref={productTagRef}>
			<div
				className={`label-box tag-box bg-white ${isEdit ? 'cursor-pointer' : ''}`}
				onClick={toggleTagModal}
			>
				<div className="all-tag d-flex flex-wrap gap-2">
					{productTags?.length > 0 &&
						productTags.map((tag, index) => (
							<span
								key={`all_tags_${index}`}
								style={{ background: tag.colorCode }}
								className="status radius without-nowrap"
							>
								{tag.text}
							</span>
						))}
					{!productTags?.length && <span>Select or add tags</span>}
				</div>
			</div>
			{showTagModal && (
				<ProductTags
					allTagList={dropdownTagList}
					productId={productId}
					currentProductTagList={currentProductTagList}
					updateTagList={updateTagList}
					fetchAllTags={getAllTags}
					setShowTagModal={setShowTagModal}
				/>
			)}

			<div className="comments-single mt-2">
				<div className="form-group">
					<textarea
						ref={remarksRef}
						placeholder="Comments"
						name="collectionRemarks"
						value={remarks}
						onChange={handleRemarksChange}
						rows={1}
						style={{ resize: 'none', overflow: 'hidden', height: '36px' }}
						disabled={!isEdit}
					/>
				</div>
			</div>
		</div>
	);
};

export default DesignTags;
